import type { AlienRuleSection } from './types';

export const invasionSections: AlienRuleSection[] = [
  {
    "id": "ai:invasion:overview",
    "scenarioId": "invasion",
    "title": "Opis trybu",
    "summary": "Jeden gracz dowodzi Obcymi, pozostali tworzą wspólną drużynę ludzi.",
    "paragraphs": [
      "Po każdej turze człowieka Dowódca Obcych wykonuje własną turę. Wszystkie niezmienione reguły gry podstawowej nadal obowiązują."
    ],
    "bullets": [
      "3–5 graczy łącznie",
      "1 Dowódca Obcych kontra 2–4 ludzi",
      "Poziom trudności źródłowy: umiarkowany"
    ],
    "relatedSectionIds": [
      "ai:invasion:victory",
      "ai:invasion:turn-order"
    ]
  },
  {
    "id": "ai:invasion:components",
    "scenarioId": "invasion",
    "title": "Komponenty",
    "bullets": [
      "Plansza Obcych",
      "5 technologii Obcych",
      "5 kopalń Obcych",
      "5 schronów Obcych",
      "4 projekty Obcych poziomu 1",
      "4 znaczniki zaawansowanych budynków Obcych",
      "20 oddziałów Obcych",
      "Naukowiec Obcych",
      "5 czerwonych znaczników akcji wielokrotnego użytku",
      "10 zielonych znaczników akcji jednorazowych",
      "10 znaczników korupcji R&D",
      "4 defensywne projekty ludzi",
      "2 znaczniki sabotażu",
      "10 tarcz",
      "4 Sentry Boty",
      "Defense Exosuit",
      "3 technologie obronne",
      "znacznik liczby oddziałów Obcych"
    ]
  },
  {
    "id": "ai:invasion:setup-humans",
    "scenarioId": "invasion",
    "title": "Przygotowanie ludzi",
    "steps": [
      "Przygotuj grę podstawową dla liczby graczy-ludzi.",
      "Pomiń indywidualne znaczniki OP. Jeden znacznik OP ustaw na 0 jako wspólny wynik ludzi.",
      "Znacznik oddziałów Obcych ustaw na polu 20 toru punktacji.",
      "Wyznacz osobę prowadzącą wspólny wynik i licznik oddziałów pozostających poza mapą.",
      "Rozdaj losowo defensywne projekty ludzi możliwie równo.",
      "Przy 3 graczach-ludziach czwarty projekt połóż odkryty obok ekspozycji projektów; pierwszy człowiek wykonujący akcję Pozyskaj projekt musi wziąć tę kartę.",
      "Każdy gracz otrzymuje zasób lub kryształ pokazany na projekcie oraz kładzie na nim znacznik zaawansowanego budynku.",
      "Właściciele projektów biorą przypisane komponenty: Exosuit, Sentry Boty, tarcze lub sabotaże oraz odpowiednie technologie."
    ],
    "warnings": [
      "Nie śledzi się osobnych wyników ludzi."
    ],
    "relatedSectionIds": [
      "ai:invasion:defensive-blueprints"
    ]
  },
  {
    "id": "ai:invasion:setup-aliens",
    "scenarioId": "invasion",
    "title": "Przygotowanie Dowódcy Obcych",
    "steps": [
      "Połóż planszę Obcych przed Dowódcą.",
      "Zakryj cztery ciemnoczerwone dodatkowe pola akcji czerwonymi znacznikami stroną osłony do góry.",
      "Piąty czerwony znacznik połóż na polu puli znaczników wielokrotnego użytku.",
      "Umieść Naukowca Obcych w prawym górnym rogu planszy.",
      "Umieść 4 oddziały Obcych na planszy Obcych; pozostałe 16 pozostaje w rezerwie.",
      "Rozłóż 4 projekty Obcych po lewej stronie planszy i połóż na nich znaczniki zaawansowanych budynków.",
      "Połóż 10 znaczników korupcji R&D na karcie R&D Corruption.",
      "Weź 3 kryształy.",
      "Połóż 1 schron Obcych na skrajnym prawym środkowym heksie mapy.",
      "Pozostałe schrony, kopalnie, technologie i zielone znaczniki trzymaj w rezerwie."
    ]
  },
  {
    "id": "ai:invasion:victory",
    "scenarioId": "invasion",
    "title": "Warunki zwycięstwa i porażki",
    "bullets": [
      "Ludzie wygrywają natychmiast po osiągnięciu wspólnie 100 OP.",
      "Obcy wygrywają natychmiast po rozmieszczeniu wszystkich 20 oddziałów na planszy głównej.",
      "Nie kończy się bieżącej tury po spełnieniu warunku.",
      "Tor pozostałych misji nie wywołuje końca gry.",
      "Nie ma punktacji końcowej."
    ]
  },
  {
    "id": "ai:invasion:turn-order",
    "scenarioId": "invasion",
    "title": "Kolejność tur",
    "steps": [
      "Gracz-ludzki wykonuje swoją turę.",
      "Dowódca Obcych wykonuje swoją turę.",
      "Procedurę powtarza się po każdym kolejnym graczu-ludzkim.",
      "Faza wahadłowca następuje po zakończeniu wszystkich tur."
    ]
  },
  {
    "id": "ai:invasion:human-tech",
    "scenarioId": "invasion",
    "title": "Korzystanie z technologii przez ludzi",
    "bullets": [
      "Ludzie mogą używać wyłącznie komponentów ludzi.",
      "Użycie technologii innego człowieka działa jak w podstawce.",
      "Za każdym razem, gdy człowiek używa technologii kolegi z drużyny, Dowódca Obcych może rozwinąć jedną własną technologię o 1 pole."
    ],
    "warnings": [
      "Nie wolno korzystać z technologii ani innych komponentów Obcych."
    ]
  },
  {
    "id": "ai:invasion:human-scoring",
    "scenarioId": "invasion",
    "title": "Bieżące zdobywanie i utrata OP",
    "bullets": [
      "Wzięcie zwykłego projektu: natychmiast utrata jego wartości OP; wynik może spaść poniżej zera.",
      "Wzięcie projektu defensywnego: bez utraty OP.",
      "Nauczenie się technologii: +1 OP.",
      "Każdy krok rozwoju technologii: +1 OP.",
      "Wejście technologią do ostatniej kolumny: dodatkowe +3 OP.",
      "Budowa schronu: +3 OP.",
      "Ulepszenie zwykłym projektem: podwójna wartość OP projektu.",
      "Ulepszenie projektem defensywnym: +3 OP.",
      "Pasujący naukowiec przy ulepszeniu: dodatkowe +3 OP.",
      "Przyjęcie statku: +3 OP; usunięcie statku z hangaru: −3 OP.",
      "Zatrudnienie naukowca: +3 OP za każdy istniejący pasujący zaawansowany budynek.",
      "Wzięcie kontraktu: natychmiast odejmij ujemną wartość.",
      "Ukończenie kontraktu: odzyskaj karę i dodaj dodatnią wartość."
    ]
  },
  {
    "id": "ai:invasion:building-restrictions",
    "scenarioId": "invasion",
    "title": "Budowa i ulepszanie przy oddziałach Obcych",
    "bullets": [
      "Nie wolno budować ani ulepszać na polu z aktywnym, stojącym oddziałem Obcych.",
      "Leżący, ogłuszony oddział może zostać wyparty.",
      "Sentry Boty i Exosuit są wypierane jak zwykłe boty i łaziki.",
      "Przy ulepszaniu pola z tarczą zwróć tarczę właścicielowi projektu Shield.",
      "Jeżeli projekt defensywny zawiera technologię, technologia trafia do pustego pola lewej kolumny laboratorium; przy braku miejsca ulepszenie jest niedozwolone."
    ]
  },
  {
    "id": "ai:invasion:executive-cost",
    "scenarioId": "invasion",
    "title": "Akcje wykonawcze ludzi",
    "paragraphs": [
      "Za każdym razem, gdy człowiek wykonuje akcję wykonawczą, Dowódca Obcych bierze jeden zielony znacznik akcji jednorazowej i kładzie go w swojej puli."
    ],
    "relatedSectionIds": [
      "ai:invasion:alien-turn"
    ]
  },
  {
    "id": "ai:invasion:defensive-blueprints",
    "scenarioId": "invasion",
    "title": "Defensywne projekty ludzi",
    "bullets": [
      "Shield: rozmieść 1 tarczę plus poziom technologii; tarcza usuwa korupcję, chroni technologię albo blokuje wejście Obcych na budynek.",
      "Sabotage: zakryj wolne pole akcji Obcych; pozostaje zablokowane do resetu.",
      "Sentry Bots: 2 aktywacje plus poziom technologii; wystawienie, ruch o 1 heks z wyparciem Obcych albo ogłuszenie wszystkich Obcych obok jednego Sentry Bota.",
      "Defense Exosuit: 2 aktywacje plus poziom technologii; wystawienie, ruch, automatyczne usuwanie ogłuszonego Obcego lub usunięcie aktywnego Obcego ze wspólnego heksu."
    ],
    "warnings": [
      "Exosuit może wejść na heks aktywnego Obcego tylko wtedy, gdy pozostaje aktywacja na jego usunięcie."
    ]
  },
  {
    "id": "ai:invasion:alien-turn",
    "scenarioId": "invasion",
    "title": "Tura Dowódcy Obcych",
    "bullets": [
      "Na turę wybierz dokładnie jedną opcję: odblokowanie pola, wykonanie akcji albo reset planszy.",
      "Najczęściej wykonywaną opcją jest wykonanie akcji.",
      "Dowódca używa wyłącznie własnych komponentów."
    ],
    "relatedSectionIds": [
      "ai:invasion:unlock",
      "ai:invasion:perform-actions",
      "ai:invasion:reset"
    ]
  },
  {
    "id": "ai:invasion:unlock",
    "scenarioId": "invasion",
    "title": "Odblokowanie dodatkowego pola",
    "steps": [
      "Zapłać 2 kryształy.",
      "Zdejmij osłonę z wybranego dodatkowego pola.",
      "Odwróć ją na stronę znacznika wielokrotnego użytku.",
      "Dołóż znacznik do swojej puli."
    ]
  },
  {
    "id": "ai:invasion:perform-actions",
    "scenarioId": "invasion",
    "title": "Wykonywanie akcji Obcych",
    "bullets": [
      "Musisz użyć przynajmniej jednego znacznika akcji.",
      "Możesz użyć maksymalnie 1 zielonego znacznika jednorazowego i 1 czerwonego wielokrotnego użytku.",
      "Możesz dodatkowo użyć Naukowca Obcych.",
      "Zielony znacznik kosztuje 1 kryształ.",
      "Jeśli masz tylko zielone znaczniki i nie możesz zapłacić, połóż znacznik na polu akcji i spasuj."
    ]
  },
  {
    "id": "ai:invasion:alien-actions",
    "scenarioId": "invasion",
    "title": "Akcje planszy Obcych",
    "bullets": [
      "Construct a Building: buduj na dowolnym pustym heksie. Schron daje oddziały równe nowemu rozmiarowi kompleksu, zmodyfikowane przez Reinforcement. Kopalnia daje kryształy równe rozmiarowi kompleksu.",
      "Obtain Blueprint: weź projekt Obcych, otrzymaj pokazany bonus.",
      "Learn New Technology: weź dowolną technologię Obcych bez kosztu zasobów.",
      "R&D: rozwiń jedną technologię o 1 pole.",
      "Upgrade Building: ulepsz schron albo kopalnię Obcych bez kosztu zasobów.",
      "Activate Advanced Building: użyj odkrytego projektu bez naukowca, po czym odwróć kartę zakrytą.",
      "Steal Crystals: zabierz do 2 kryształów z mapy i/lub magazynu; zdobytych kryształów nie wydasz w tej samej turze.",
      "Deploy beside Buildings: wystaw 1 + poziom Deployment oddziałów na pustych heksach obok budynków Obcych.",
      "Deploy in Buildings: wystaw 1 + poziom Deployment oddziałów na niezaawansowanych budynkach Obcych.",
      "Move Troopers: rozdziel 1 + poziom Mobilization punktów ruchu; 1 punkt może podnieść ogłuszonego Obcego."
    ]
  },
  {
    "id": "ai:invasion:alien-blueprints",
    "scenarioId": "invasion",
    "title": "Akcje zaawansowanych budynków Obcych",
    "bullets": [
      "Alien Infection: każdy człowiek przenosi 1 kolonistę z kwater do obszaru roboczego.",
      "Vigilant: przesuń wahadłowiec o 1 pole bez zmiany jego kierunku.",
      "Abduction: odeślij ludzkiego naukowca na jego kartę.",
      "R&D Corruption: połóż korupcję na technologii człowieka; technologia nadal działa, ale nie może być rozwijana do usunięcia korupcji."
    ]
  },
  {
    "id": "ai:invasion:alien-scientist",
    "scenarioId": "invasion",
    "title": "Naukowiec Obcych",
    "steps": [
      "Przenieś Naukowca Obcych z planszy na pole akcji odkrytego projektu.",
      "Wykonaj akcję zaawansowanego budynku.",
      "Naukowiec pozostaje na karcie do resetu planszy."
    ]
  },
  {
    "id": "ai:invasion:troopers",
    "scenarioId": "invasion",
    "title": "Ruch i rozmieszczanie oddziałów",
    "bullets": [
      "Oddział nie może wejść na budynek z tarczą ani na zaawansowany budynek.",
      "Może przechodzić przez zajęte heksy, lecz nie może zakończyć tam ruchu.",
      "Kończąc ruch na krysztale, kaflu badań lub odkrycia, niszczy ten element.",
      "Ogłuszenie oznacza położenie oddziału.",
      "1 punkt ruchu może podnieść ogłuszony oddział.",
      "Każde dodanie oddziału na mapę zmniejsza licznik; każde usunięcie zwiększa licznik."
    ]
  },
  {
    "id": "ai:invasion:reset",
    "scenarioId": "invasion",
    "title": "Reset planszy Obcych",
    "paragraphs": [
      "Reset jest dozwolony, gdy odkryte są najwyżej 2 pola akcji albo nie pozostał żaden znacznik akcji."
    ],
    "steps": [
      "Zużyte zielone znaczniki z pól akcji odłóż do rezerwy.",
      "Czerwone znaczniki z pól akcji wracają do puli.",
      "Znaczniki sabotażu wracają do ludzi.",
      "Naukowiec Obcych wraca na planszę.",
      "Zakryte projekty Obcych odwróć odkryte."
    ]
  }
];
